import { useState, useEffect} from 'react';
// Material UI Library
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';


// Translation Library
import { useTranslation } from 'react-i18next';


const baseURL = process.env.REACT_APP_API_BASE_URL;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function WorkShops({formData, handleChange, errorsData}) {
    const { t,i18n } = useTranslation();
    let [workshops, setWorkShops] = useState([])

      useEffect(()=>{
        const fetchWorkShops  = async ()=>{
          try {
            const res = await fetch(`${baseURL}/work-shops`)
            if (!res.ok) {
            throw new Error(`API Error: ${res.status}`);
            }
            else {
              const data = await res.json();
              setWorkShops(data.data)
              // console.log(data.data)
            }
          }
          catch(error) {
            console.log(error)
          }
        }
        fetchWorkShops()
      },[])

  return (
    <>
      <FormControl className="w-full">
        <InputLabel error={errorsData.workshops}>{t("workshops")}</InputLabel>
        <Select
            multiple
            error={errorsData.workshops}
            name='workshops'
            value={formData.workshops}
            onChange={handleChange}
            input={<OutlinedInput label={t("workshops")} />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: "wrap", gap: 1, maxHeight: 200, overflowY: 'auto' }}>
              {selected.map((element1) => {
                // console.log(selected)
                  const workshop = workshops.find(element2 => element2.id === element1);
                  // console.log(workshop)
                  if (!workshop) return null;

                  return (
                  <Box
                      key={element1}
                      sx={{
                      border: '1px solid #ccc',
                      width: "fit-content",
                      padding: "0px 5px",
                      borderRadius: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.3,
                      backgroundColor: '#f5f5f5'
                      }}
                  >
                      <Box sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>{i18n.language === "en" ? workshop.workshop: workshop.workshop_ar}</Box>
                      <Box sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>{i18n.language === "en" ? workshop.instructor: workshop.instructor_ar}</Box>
                      <Box sx={{ fontSize: '0.8rem', color: 'primary.main' }}>{workshop.Date}</Box>
                      <Box sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>{workshop.time}</Box>
                  </Box>
                  );
              })}
              </Box>
            )}
            MenuProps={MenuProps}
            >
            {workshops.map((workshopObj, index) => [
                <MenuItem key={workshopObj.id} value={workshopObj.id}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Box sx={{ fontWeight: 'bold', fontSize: '0.95rem', whiteSpace: 'normal' }}>{i18n.language === "en" ? workshopObj.workshop: workshopObj.workshop_ar}</Box>
                      <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', whiteSpace: 'normal' }}>{i18n.language === "en" ? workshopObj.instructor: workshopObj.instructor_ar}</Box>
                      <Box sx={{ fontSize: '0.8rem', color: 'primary.main', whiteSpace: 'normal' }}>{workshopObj.Date}</Box>
                      <Box sx={{ fontSize: '0.8rem', color: 'text.secondary', whiteSpace: 'normal' }}>{workshopObj.time}</Box>
                  </Box>
                </MenuItem>,
                  index !== workshops.length - 1 && (
                    <MenuItem key={`divider-${workshopObj.id}`} disabled sx={{ p: 0, cursor: 'default' }}>
                      <div className='w-full h-[1px] bg-gray-500 mt-2 mb-2'></div>
                    </MenuItem>
                  ),
            ])}
        </Select>
        {errorsData.workshops 
        ? 
        (
          <FormHelperText sx={{ color: 'error.main' }}>{t("please_select_at_least_one_of_workshops")}</FormHelperText>
        )
        : ""}
      </FormControl>
    </>
  );
}
